import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'
import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { projects } from '../selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , projects: projects(state)
	})
)

export class ProjectCombobox extends Component{
	render(){
		let { props } = this
		return(
			<Combobox
				icon={
					<img
						src={'/' + process.env.REACT_APP_NAME + "/static/img/Projects_green.png"}
						style={{
							marginTop: "-3px"
						  , width: "20px"
						}}
					/>
				}
				link={`/manager/project/${props.object.projectID}`}
				exist={(props.object && props.object.projectID)}
				text={(props.object && props.object.projectID && props.projects[props.object.projectID])?props.projects[props.object.projectID].title:""}
				hintText={<span>Enter project</span>}
				noDelete={true}
				searchText={
					(props.object.projectID&&props.projects[props.object.projectID])?
						props.projects[props.object.projectID].title
						: ''
				}
				dataSource={
					R.map(agent => ({
						text: `${agent.title}`
					  , value: (
							<MenuItem
								key={agent._id}
								primaryText={agent.title}
							/>
						)
					  , id: agent._id
				  }), sortSev(props.projects, "title", "_id"))
				}
				onChange={(obj)=>{
						// if(props.object.ownerID && props.object.ownerID != obj.id){
						// 	props.STAGE({
						// 		_id: props.object.ownerID
						// 	  , properties:
						// 	  (
						// 		  props.owners[props.object.ownerID].properties
						// 		  && props.owners[props.object.ownerID].properties.length
						// 	  )?
						// 	  R.reject(property => property == props.objectID, props.owners[props.object.ownerID].properties)
						// 	  : []
						// 		})
						// }
						obj = obj || {}
						props.STAGE({
							_id: props.objectID
						  , projectID: obj.id
						})
						// if(props.owners[obj.id].properties&&!props.owners[obj.id].properties.length){
						// 	props.STAGE({
						// 			_id: obj.id
						// 		, properties: [props.objectID]
						// 	})
						// }
						// if(props.owners[obj.id].properties&&props.owners[obj.id].properties.length&&!R.contains(props.objectID, props.owners[obj.id].properties)){
						// 	props.STAGE({
						// 			_id: obj.id
						// 		, properties:
						// 		(
						// 			props.owners[obj.id].properties
						// 			&& props.owners[obj.id].properties.length
						// 		)?
						// 		[...props.owners[obj.id].properties, props.objectID]
						// 		: [props.objectID]
						// 	})
						// }
					}
				}
				// DELETE={()=>{
				// 	props.STAGE({
				// 		_id: props.object.projectID
				// 	  , _id: ""
				// 	})
				// }}
			/>
		)
	}
}

export default connect(select, dataActions)(ProjectCombobox)



// WEBPACK FOOTER //
// ./src/components/ProjectCombobox.js